import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../../context/I18nContext';
import { resolveRouteMeta } from '../../seo/routeMeta';
import { applyHeadMeta } from '../../seo/headTags';
import { applyStructuredData, buildHomeStructuredData } from '../../seo/structuredData';
import { FROM_PRICE, FROM_PRICE_AMOUNT } from '../home/homeUtils';

/** Keeps <head> (title, description, canonical, robots) in step with the current route and language. */
export default function RouteMeta() {
  const { pathname } = useLocation();
  const { t, locale } = useI18n();

  useEffect(() => {
    const { indexable, key, ownTitle, canonical } = resolveRouteMeta(pathname);
    const description = key ? t(`seo.${key}.description`, { price: FROM_PRICE }) : undefined;
    const title = key && !ownTitle ? t(`seo.${key}.title`) : undefined;
    applyHeadMeta({ indexable, canonical, description, title });
    applyStructuredData(key === 'home' ? buildHomeStructuredData({ lowPrice: FROM_PRICE_AMOUNT, description }) : null);
  }, [pathname, locale, t]);

  return null;
}
